// extracted by mini-css-extract-plugin
export default {"container":"Calculator_container__KP27H"};